module.exports = __webpack_public_path__ + "static/media/Icon.f97f0bc2.gif";